module.exports = __webpack_public_path__ + "static/media/nuclear-energy.67de5d71.svg";